import MediumEditor from 'medium-editor';

const BlockquoteExtension = MediumEditor.extensions.button.extend({
  name: 'blockquote-extension',

  tagNames: ['blockquote'],
  contentDefault: '<span class="medium-toolbar-blockquote">&lsquo;</span><span class="medium-toolbar-blockquote">&lsquo;</span>',
  contentFA: '<span class="medium-toolbar-blockquote">&lsquo;</span><span class="medium-toolbar-blockquote">&lsquo;</span>',
  aria: 'blockquote',
  action: 'blockquote',

  init() {
    MediumEditor.extensions.button.prototype.init.call(this);

    this.setStateForButton.bind(this);
  },

  handleClick() {
    if (this.firstClick) {
      $(window.getSelection().focusNode).parents('blockquote').addClass('--standout');
    } else {
      MediumEditor.util.execFormatBlock(document, 'blockquote');
    }

    this.setStateForButton();

    this.base.checkContentChanged();
  },

  isAlreadyApplied() {
    this.setStateForButton();

    return this.firstClick || this.secondClick;
  },

  setStateForButton() {
    const blockquoteNode = $(window.getSelection().focusNode).parents('blockquote').get(0);

    this.firstClick = blockquoteNode && !blockquoteNode.classList.contains('--standout');
    this.secondClick = blockquoteNode && blockquoteNode.classList.contains('--standout');

    const { childNodes } = this.button;

    childNodes[0].classList.remove('--active');
    childNodes[1].classList.remove('--active');

    if (this.firstClick) {
      childNodes[1].classList.add('--active');
    } else if (this.secondClick) {
      childNodes[0].classList.add('--active');
      childNodes[1].classList.add('--active');
    }
  },
});

export default BlockquoteExtension;
